import React from 'react';
import { formatLongPlanningDate } from '../../lib/planningDates';

const EMPTY_OR_LABEL = /^(?:[:\s-]*|unknown|not available|n\/?a|blank field|decision|decision issued date|appeal status|appeal decision|appeal decision date|local review body status|local review body decision|there are|documents)$/i;

// Keep the council's outcome separate from application status: consultation
// responses and EIA screening decisions are not grants of planning permission.
export default function CouncilDecisionFacts({ application, card = false }) {
  const value = application?.portal_decision;
  const decision = typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : '';
  if (EMPTY_OR_LABEL.test(decision)) return null;

  const rawDate = application?.portal_decision_issued_date;
  const date = typeof rawDate === 'string' && /^\d{4}-\d{2}-\d{2}(?:T|$)/.test(rawDate)
    ? formatLongPlanningDate(rawDate) : null;

  const facts = (
    <>
      <div className="pr-fact">
        <dt>Council decision</dt>
        <dd>{decision}</dd>
      </div>
      {date ? (
        <div className="pr-fact">
          <dt>Decision issued</dt>
          <dd><time dateTime={rawDate.slice(0, 10)}>{date}</time></dd>
        </div>
      ) : null}
    </>
  );
  return card ? (
    <dl className="pr-record-card px-4" data-overview-section="council-decision">{facts}</dl>
  ) : facts;
}
